import React from "react";
import clsx from "clsx";

interface Props {
  className?: string;
  onClick?: any;

  style?: any;
}

const Divider = (props: Props) => {
  let className = clsx("divider", `${props.className}`);

  return (
    <div
      className={className}
      style={props.style ? props.style : {}}
      onClick={() => props.onClick()}
    ></div>
  );
};

export default Divider;
